import React from 'react';

function HotelServices() {
    const services = [
        {
            icon: 'fas fa-shield-alt',
            title: 'Best Price Guarantee',
            description: 'Find a lower price? We\'ll match it and give you an extra 10% off'
        },
        {
            icon: 'fas fa-calendar-times',
            title: 'Free Cancellation',
            description: 'Cancel up to 24 hours before your stay for a full refund'
        },
        {
            icon: 'fas fa-headset',
            title: '24/7 Support',
            description: 'Get help anytime, anywhere with our round-the-clock customer service'
        },
        {
            icon: 'fas fa-star',
            title: 'Verified Reviews',
            description: 'Real reviews from real guests to help you make the right choice'
        }
    ];

    return (
        <div className="hotel-services-area py-5 bg-light">
            <div className="container">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-8 text-center">
                        <h2 className="section-title">Why book with us?</h2>
                        <p className="section-subtitle">
                            We make hotel booking simple, secure, and rewarding
                        </p>
                    </div>
                </div>
                <div className="row">
                    {services.map((service, index) => (
                        <div key={index} className="col-lg-3 col-md-6 mb-4">
                            <div className="service-card h-100">
                                <div className="service-icon">
                                    <i className={service.icon}></i>
                                </div>
                                <div className="service-content">
                                    <h5>{service.title}</h5>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default HotelServices;
